import styled from 'styled-components';
import LoadingButton from 'components/shared/LoadingButton/LoadingButton';

export const PageContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  padding-bottom: 30px;
  width: 100%;
  `;

export const MobileTitle = styled.div`
  display:none;
  @media(max-width: 705px) {
    display:block;
  }
`;

export const DesktopTitle = styled.div`
  @media(max-width: 705px) {
    display:none;
  }
`;

export const PaymentContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 3;
  padding-top: 30px;
  margin: 0 20px;
  max-width: 600px;
  @media(max-width: 705px) {
    order: 2;
  }
`;

export const GoalcardSummaryContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 1;
  min-height: 250px;
  padding-top: 30px;
  margin: 0 20px;
  max-width: 350px;
  @media(max-width: 705px) {
    order: 1;
  }
`;

export const CardPaymentContainer = styled.div`
  border: solid 1px lightgray;
  border-radius: 10px;
  padding: 20px 15px;
  max-width: 600px;
`;

export const CardNameInput = styled.input`
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  -webkit-transition: box-shadow 0ms ease;
  transition: box-shadow 0ms ease;
  width:100%;
  &:focus {
    border-color: #500F71;
    transition: border-color 0ms ease;
  }
`;

export const ButtonContainer = styled.div`
  display:flex;
  flex-direction: column;
  padding-top: 20px;
`;

export const Button = styled(LoadingButton)`
  display: inline-block;
  min-width: 140px;
  height: 45px;
  line-height: 45px;
  outline: none;
  border: 0;
  border-radius: 5px;
  text-transform: uppercase;
  text-align: center;
  opacity: 1;
  padding: 0 18px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 1em;
  position: relative;
  color: white;
  font-family: 'Avenir Next LT W01 Demi';
  width: 180px;
    ${(props) => (props.disabled
    ? 'background-color: #a3a3a3;'
    : 'background-color: #F3A802;')}
`;

export const TOSLabel = styled.label`
  margin-top: 10px;
  font-size: .95em;
  font-weight: 400;
  line-height: 1.6em;
  font-family: "AvenirNextLTW01-Regular";
`;

export const TOSLink = styled.a`
  cursor: pointer;
  opacity: 1;
  border-bottom: 1px solid;
  color: #17BFDD;
  text-decoration: none;
`;

export const GoalcardSummaryBoxContainer = styled.div`
`;

export const GoalcardSummaryBoxHeading = styled.div`
  color: #fff;
  display: flex;
  align-items: stretch;
  border-radius: 4px 4px 0 0;
  background-color: #09798D;
`;

export const GoalcardSummaryHeadingTitle = styled.label`
  font-size: 20px;
  margin: 10px 10px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  line-height: 1.1;
  color: inherit;
  font-family: inherit;
  font-family: "AvenirNextLTW01-Regular";
`;

export const GoalcardSummaryBoxContent = styled.div`
  padding: 20px 20px 0px 20px;
  text-align: center;
  border: 1px solid #09798D;
  border-radius: 0 0 5px 5px;
  font-size: 12px;
`;

export const GoalcardSummaryBoxImage = styled.img`
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, .29);
  margin-bottom: 20px;
  vertical-align: middle;
  border: 0;
  text-align: center;
`;

export const SummaryDetail = styled.div`
  display:flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: .95em;
  font-weight: 400;
  margin-bottom: 0.4em;
  line-height: 1.6em;
  text-align: left;
`;

export const LabelDetail = styled.label`
  display: inline-block;
  min-width: 50px;
  color: #999;
  font-size: 1.20em;
  font-weight: 400;
  line-height: 1.6em;
  font-family: "AvenirNextLTW01-Regular";
`;

export const LabelDetailValue = styled.label`
  font-weight: normal;
  line-height: 1.6em;
  text-align: ${(props) => (props.alignment ? props.alignment : 'left')};
  font-size: 1.20em;
  font-family: "AvenirNextLTW01-Regular";
  width: ${(props) => (props.width ? props.width : '70%')}; ;
`;

export const TotalDetail = styled.div`
  display:flex;
  padding: 10px 0px 12px 0px;
  border-top: 1px solid #d2d2d2;
  flex-direction: row;
  justify-content: space-between;
`;

export const TotalDetailLabel = styled.label`
  font-family: "AvenirNextLTW01-Regular";
  font-size: 20px;
  font-weight: 400;
  line-height: 1.6em;
  text-align: ${(props) => (props.alignment ? props.alignment : 'left')};
  margin-bottom: 0px;
`;

export const Divider = styled.div`
  margin-bottom: 20px;
`;
